// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MO4dA","h1":"styles_h1__lBLID","h2":"styles_h2__x7OMK","p":"styles_p__NTVdB"};